<template>
  <div class="question box box-shadow"></div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'Question',
  props: ['index', 'question', 'answers', 'value', 'id', 'type'],
  data: function () {
    return {
      saving: false,
      error: null
    }
  },
  methods: {
    createPayload: function () {
      return {
        kitId: this.$route.params.kitId, // Todo: consider refactor with props
        type: this.$route.params.type,
        result: {
          questionId: this.id,
          answers: (this.type === 'MULTI_OPTION' || this.type === 'SINGLE_OPTION') ? this.value : [], // TODO: CONSIDER REFACTOR
          answerString: (this.type !== 'SINGLE_OPTION') ? String(this.value) : ''
        }
      }
    },
    save: function () {
      this.saving = true
      const payload = this.createPayload()
      // Save
      this.$store.dispatch('putSurveyQuestion', payload).then(success => {
        this.saving = false
        this.fetchSurveys()
      }).catch(error => {
        this.saving = false
        this.error = error
      })
    },
    fetchSurveys () {
      this.$store.dispatch('getUserKits').then(response => {
        self.isLoading = false
      }, error => {
        console.log(error)
      })
    }
  },
  watch: {
    value: _.debounce(function (newVal) {
      this.save()
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/Question.vue